import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { ButtonSearch, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationsMapSearchArea = (props: SearchAreaProps) => {
  const { match } = useResponsive();
  const { formatMessage } = useIntl();

  const wrapperStyle = [styles.wrapper, match([undefined, styles.wrapperSM])];

  return (
    <View style={wrapperStyle} pointerEvents="box-none">
      <ButtonSearch
        accessibilityLabel={formatMessage(messages.locationMapSearchArea)}
        accessibilityHint={formatMessage(messages.locationMapSearchArea)}
        isLoading={props.isLoading}
        disabled={props.disabled}
        onPress={props.onPress}
      >
        {formatMessage(messages.locationMapSearchArea)}
      </ButtonSearch>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    ...StyleSheet.absoluteFill,
    bottom: 'auto',
    zIndex: 1,
    flexDirection: 'row',
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
  },
  wrapperSM: {
    justifyContent: 'center',
    paddingTop: theme.spacing['6'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  locationMapSearchArea: {
    defaultMessage: 'Search area',
    description: 'Location | Map Search Area',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type SearchAreaProps = Pick<
  React.ComponentProps<typeof ButtonSearch>,
  'onPress' | 'isLoading' | 'disabled'
>;
